import { render } from "./EstateNewCard.vue?vue&type=template&id=44e2d5bf&scoped=true"
import script from "./EstateNewCard.vue?vue&type=script&lang=js"
export * from "./EstateNewCard.vue?vue&type=script&lang=js"

import "./EstateNewCard.vue?vue&type=style&index=0&id=44e2d5bf&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e2d5bf"]])

export default __exports__